module.exports = __webpack_public_path__ + "img/heart.5db60141.png";